import dictionaryService from './dictionaryService';

export default dictionaryService;



// WEBPACK FOOTER //
// ./src/services/dictionary/index.ts